import React, { Component } from 'react';
import HomePageComponent from '../pages/home'
import ContactPageComponent from '../pages/contact'
import HelpPageComponent from '../pages/help'
import CookiePageComponent from '../pages/cookie'
import CopyrightPageComponent from '../pages/copyright'
import PrivacyPageComponent from '../pages/privacy'
import SecurityPageComponent from '../pages/security'
import TermsPageComponent from '../pages/terms'
import DisclaimerPageComponent from '../pages/disclaimer'
import VendorPageComponent from '../pages/vendor'
import TechnologyPageComponent from '../pages/technology'
import PageNotFoundComponent from '../../shared/errors/404'

class RoutesComponent extends Component {
    render() {
        const { page } = this.props
        return (
            <div className="pb-route-component-content">
                { page === "" ? <HomePageComponent /> : <></> }
                { page === "contact" ? <ContactPageComponent /> : <></> }
                { page === "help" ? <HelpPageComponent /> : <></> }
                { page === "cookie" ? <CookiePageComponent /> : <></> }
                { page === "copyright" ? <CopyrightPageComponent /> : <></> }
                { page === "privacy" ? <PrivacyPageComponent /> : <></> }
                { page === "security" ? <SecurityPageComponent /> : <></> }
                { page === "terms" ? <TermsPageComponent /> : <></> }
                { page === "disclaimer" ? <DisclaimerPageComponent /> : <></> }
                { page === "vendor" ? <VendorPageComponent /> : <></> }
                { page === "technology" ? <TechnologyPageComponent /> : <></> }
                { page === "*" ? <PageNotFoundComponent /> : <></> }
            </div>
        )
    }
}

export default RoutesComponent
